import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import usePersonStore from '../../store/personStore';

const RequireAuth = () => {
  const authData = usePersonStore((store) => store.authData);
  const location = useLocation();
  const isLoggedIn = localStorage.getItem('isLoggedIn');

  if (authData?.access_token || isLoggedIn) {
    return <Outlet />;
  }

  return <Navigate to="/" state={{ from: location }} replace />;
};

export default RequireAuth;
